/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import utils from '../../utils'
import { Link } from 'react-router-dom'
import logo from '../../assets/logo.jpeg'
import { 
    LuHammer,
  LuInfo, 
  LuLayoutGrid, 
  LuPenSquare, 
} from "react-icons/lu";

function NavBar(props) {
    function openModal() {
        const openBtn = document.getElementById("contact-modal-open-btn")
        openBtn.click()
    }
    return (
        <div className='bg-base-100/90 shadow-md z-30 sticky top-0 backdrop-blur-sm'>
            <div className="container mx-auto navbar ">
                <div className="md:space-x-2 navbar-start">
                    <div>
                        <img src={logo} alt="logo" className='hidden md:h-16 md:block rounded-md' />
                    </div>
                    <div className=''>
                        <Link className="btn btn-ghost upper-case font-extrabold text-secondary" to='/'>{utils.siteName}</Link>
                    </div>
                </div>
                <div className="navbar-center md:space-x-2">
                    <ul className='menu menu-horizontal items-center'>
                        <li className='hidden md:inline'>
                            <Link
                                to='/about' >
                                <LuInfo size={20} /> About</Link>
                        </li>
                        <li className='hidden md:inline'><Link to="/houses" className=""><LuLayoutGrid size={20}/> All Plans</Link></li>
                        <li className='hidden md:inline'><Link to="/blog" className=""><LuPenSquare size={20}/> Blog</Link></li>
                    </ul>
                </div>
                <div className=" navbar-end ">
                    <div className="">
                        <ul className="menu menu-horizontal items-center md:space-x-2">
                            <li className='hidden md:inline'>
                                <a
                                    className='bg-primary text-on-primary px-6 py-2.5 rounded-lg font-body text-sm font-bold tracking-wide uppercase active:scale-95 transition-transform hover:bg-primary-container'
                                    onClick={() => openModal()}
                                ><LuHammer /> Custom Plan</a>
                            </li>
                            <li>
                                <label htmlFor="nav-drawer">
                                    <div className="btn btn-ghost btn-circle ">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default NavBar